export default {"src":"/_next/static/media/star.85adafda.svg","height":16,"width":16};